function createShareUrl({ title, text, url }) {
  if (title) text = title + ' - ' + text
  return `https://twitter.com/intent/tweet?text=${text}&url=${url}`
}

export default {
  id: 'twitter',
  title: 'Twitter',
  createShareUrl
}
